<template>
  <div class="hemiao-page">
    <!-- 页面标题 -->
    <div class="page-header">
      <div class="container">
        <h1>禾苗商城</h1>
        <p>一站式企业采购平台</p>
      </div>
    </div>

    <!-- 产品介绍 -->
    <section class="product-intro">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <img 
              src="../assets/images/hemiao.aafbc56b.gif" 
              alt="禾苗商城" 
              class="intro-img img-fluid"
            >
          </div>
          <div class="col-md-6">
            <div class="intro-content">
              <h2>禾苗商城介绍</h2>
              <p>禾苗商城是专为企业打造的一站式采购平台，通过集成多家供应商资源，为企业提供全方位的采购解决方案。我们致力于帮助企业降低采购成本，提高采购效率，优化采购流程。</p>
              <div class="intro-highlights">
                <div class="highlight-item">
                  <i class="iconfont icon-check-circle"></i>
                  <span>海量商品资源，满足企业多样化采购需求</span>
                </div>
                <div class="highlight-item">
                  <i class="iconfont icon-check-circle"></i>
                  <span>智能比价系统，确保最优采购价格</span>
                </div>
                <div class="highlight-item">
                  <i class="iconfont icon-check-circle"></i>
                  <span>规范的供应商管理，保证商品质量</span>
                </div>
                <div class="highlight-item">
                  <i class="iconfont icon-check-circle"></i>
                  <span>全流程电子化管理，提高采购透明度</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 核心功能 -->
    <section class="core-features">
      <div class="container">
        <div class="section-header text-center">
          <h2>核心功能</h2>
          <p>强大的功能模块，满足企业采购的各种需求</p>
        </div>
        <div class="row feature-list">
          <div class="col-md-4">
            <div class="feature-card">
              <div class="feature-icon">
                <img src="../assets/images/1.670c7eef.gif" alt="智能采购">
              </div>
              <h3>智能采购</h3>
              <p>基于企业历史采购数据，智能推荐最佳供应商和产品，自动生成采购计划，提高采购效率。</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="feature-card">
              <div class="feature-icon">
                <img src="../assets/images/2.0a9650a7.gif" alt="供应商管理">
              </div>
              <h3>供应商管理</h3>
              <p>完善的供应商资质审核、评估体系，实时监控供应商表现，确保供应链稳定可靠。</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="feature-card">
              <div class="feature-icon">
                <img src="../assets/images/exp.595da4b7.gif" alt="订单管理">
              </div>
              <h3>订单管理</h3>
              <p>全流程订单跟踪，从下单到收货的各个环节实时监控，支持多种支付方式和发票管理。</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="feature-card">
              <div class="feature-icon">
                <img src="../assets/images/banner.png" alt="库存管理">
              </div>
              <h3>库存管理</h3>
              <p>实时监控库存水平，自动预警，避免库存积压或短缺，优化企业库存结构。</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="feature-card">
              <div class="feature-icon">
                <img src="../assets/images/placeholder.svg" alt="数据分析">
              </div>
              <h3>数据分析</h3>
              <p>多维度数据分析，生成采购报告，帮助企业洞察采购趋势，优化采购策略。</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="feature-card">
              <div class="feature-icon">
                <img src="../assets/images/placeholder.svg" alt="审批流程">
              </div>
              <h3>审批流程</h3>
              <p>灵活的多级审批流程，支持移动端审批，提高审批效率，确保采购合规。</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 优势特点 -->
    <section class="advantages">
      <div class="container">
        <div class="section-header text-center">
          <h2>优势特点</h2>
          <p>为企业提供全方位的采购解决方案</p>
        </div>
        <div class="advantage-grid">
          <div class="advantage-item">
            <div class="advantage-number">01</div>
            <div class="advantage-content">
              <h3>降低成本</h3>
              <p>通过集中采购、智能比价，帮助企业降低采购成本15%-30%</p>
            </div>
          </div>
          <div class="advantage-item">
            <div class="advantage-number">02</div>
            <div class="advantage-content">
              <h3>提高效率</h3>
              <p>全流程电子化，将采购周期缩短50%，大大提高工作效率</p>
            </div>
          </div>
          <div class="advantage-item">
            <div class="advantage-number">03</div>
            <div class="advantage-content">
              <h3>优化管理</h3>
              <p>规范采购流程，提高采购透明度，有效防范采购风险</p>
            </div>
          </div>
          <div class="advantage-item">
            <div class="advantage-number">04</div>
            <div class="advantage-content">
              <h3>数据驱动</h3>
              <p>基于大数据分析，为企业提供科学的采购决策支持</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 适用场景 -->
    <section class="use-cases">
      <div class="container">
        <div class="section-header text-center">
          <h2>适用场景</h2>
          <p>广泛适用于各类企业的采购需求</p>
        </div>
        <div class="row case-list">
          <div class="col-md-6">
            <div class="case-card">
              <img 
                src="../assets/images/hemiao.aafbc56b.gif" 
                alt="中小企业日常采购" 
                class="case-img img-fluid"
              >
              <div class="case-content">
                <h3>中小企业日常采购</h3>
                <p>为中小企业提供便捷的采购渠道，无需大量人力物力，即可完成高效采购。</p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="case-card">
              <img 
                src="../assets/images/hongyun.7412facc.gif" 
                alt="大型企业集中采购" 
                class="case-img img-fluid"
              >
              <div class="case-content">
                <h3>大型企业集中采购</h3>
                <p>支持多部门、多分支机构的集中采购管理，实现规模化采购优势。</p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="case-card">
              <img 
                src="../assets/images/ai.f04e201c.gif" 
                alt="政府采购" 
                class="case-img img-fluid"
              >
              <div class="case-content">
                <h3>政府采购</h3>
                <p>符合政府采购法规要求，提供透明、公正的采购环境。</p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="case-card">
              <img 
                src="../assets/images/banner.png" 
                alt="行业供应链采购" 
                class="case-img img-fluid"
              >
              <div class="case-content">
                <h3>行业供应链采购</h3>
                <p>为特定行业提供专业化的采购解决方案，满足行业特殊需求。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 合作案例 -->
    <section class="cooperation-cases">
      <div class="container">
        <div class="section-header text-center">
          <h2>合作案例</h2>
          <p>众多知名企业的共同选择</p>
        </div>
        <div class="row client-list">
          <div class="col-md-2 col-sm-4 col-6">
            <div class="client-logo">
              <img 
                src="../assets/images/banner.png" 
                alt="客户logo" 
                class="img-fluid"
              >
            </div>
          </div>
          <div class="col-md-2 col-sm-4 col-6">
            <div class="client-logo">
              <img 
                src="../assets/images/1.670c7eef.gif" 
                alt="客户logo" 
                class="img-fluid"
              >
            </div>
          </div>
          <div class="col-md-2 col-sm-4 col-6">
            <div class="client-logo">
              <img 
                src="../assets/images/2.0a9650a7.gif" 
                alt="客户logo" 
                class="img-fluid"
              >
            </div>
          </div>
          <div class="col-md-2 col-sm-4 col-6">
            <div class="client-logo">
              <img 
                src="../assets/images/exp.595da4b7.gif" 
                alt="客户logo" 
                class="img-fluid"
              >
            </div>
          </div>
          <div class="col-md-2 col-sm-4 col-6">
            <div class="client-logo">
              <img 
                src="../assets/images/hemiao.aafbc56b.gif" 
                alt="客户logo" 
                class="img-fluid"
              >
            </div>
          </div>
          <div class="col-md-2 col-sm-4 col-6">
            <div class="client-logo">
              <img 
                src="../assets/images/hongyun.7412facc.gif" 
                alt="客户logo" 
                class="img-fluid"
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系咨询 -->
    <section class="contact-consult">
      <div class="container">
        <div class="contact-content">
          <h2>立即咨询</h2>
          <p>了解更多禾苗商城的产品信息和定制化解决方案</p>
          <div class="contact-actions">
            <a href="tel:15392850129" class="contact-btn btn-primary">
              <i class="iconfont icon-phone"></i>
              电话咨询
            </a>
            <a href="mailto:service2@hemiao100.com" class="contact-btn btn-secondary">
              <i class="iconfont icon-mail"></i>
              邮件咨询
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Hemiao'
}
</script>

<style scoped>
.hemiao-page {
  min-height: 100vh;
}

/* 页面标题 */
.page-header {
  background-image: url('../assets/images/hemiaomall.jpg');
  background-size: cover;
  background-position: center;
  color: white;
  padding: 5rem 0;
  text-align: center;
}

.page-header h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.page-header p {
  font-size: 1.5rem;
  opacity: 0.9;
}

/* 产品介绍 */
.product-intro {
  padding: 5rem 0;
}

.intro-img {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.intro-content {
  padding: 2rem;
}

.intro-content h2 {
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 1.5rem;
}

.intro-content p {
  font-size: 1.1rem;
  color: #666;
  line-height: 1.8;
  margin-bottom: 2rem;
}

.intro-highlights {
  margin-top: 2rem;
}

.highlight-item {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  color: #28a745;
  font-size: 1.1rem;
}

.highlight-item i {
  margin-right: 1rem;
}

/* 核心功能 */
.core-features {
  padding: 5rem 0;
  background-color: #f8f9fa;
}

.section-header {
  margin-bottom: 3rem;
}

.section-header h2 {
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 1rem;
  position: relative;
  display: inline-block;
}

.section-header h2::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background-color: #28a745;
}

.section-header p {
  font-size: 1.2rem;
  color: #666;
  margin-top: 1.5rem;
}

.feature-list {
  margin: 0 -15px;
}

.feature-card {
  background-color: white;
  border-radius: 8px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  text-align: center;
  height: 100%;
}

.feature-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.feature-icon {
  margin-bottom: 1.5rem;
}

.feature-icon img {
  width: 80px;
  height: 80px;
}

.feature-card h3 {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 1rem;
}

.feature-card p {
  color: #666;
  line-height: 1.6;
}

/* 优势特点 */
.advantages {
  padding: 5rem 0;
}

.advantage-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.advantage-item {
  display: flex;
  align-items: flex-start;
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 2rem;
  transition: all 0.3s ease;
}

.advantage-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.advantage-number {
  font-size: 3rem;
  color: #28a745;
  opacity: 0.2;
  font-weight: bold;
  margin-right: 1.5rem;
  line-height: 1;
}

.advantage-content h3 {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 0.5rem;
}

.advantage-content p {
  color: #666;
  line-height: 1.6;
}

/* 适用场景 */
.use-cases {
  padding: 5rem 0;
  background-color: #f8f9fa;
}

.case-list {
  margin: 0 -15px;
}

.case-card {
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  margin-bottom: 2rem;
}

.case-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.case-img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.case-content {
  padding: 1.5rem;
}

.case-content h3 {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 1rem;
}

.case-content p {
  color: #666;
  line-height: 1.6;
}

/* 合作案例 */
.cooperation-cases {
  padding: 5rem 0;
}

.client-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.client-logo {
  padding: 2rem;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 1rem;
  text-align: center;
  transition: all 0.3s ease;
}

.client-logo:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.client-logo img {
  max-height: 60px;
  max-width: 100%;
  filter: grayscale(1);
  transition: filter 0.3s ease;
}

.client-logo:hover img {
  filter: grayscale(0);
}

/* 联系咨询 */
.contact-consult {
  padding: 5rem 0;
  background: linear-gradient(135deg, #28a745 0%, #1e7e34 100%);
  color: white;
  text-align: center;
}

.contact-content h2 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.contact-content p {
  font-size: 1.2rem;
  margin-bottom: 2rem;
  opacity: 0.9;
}

.contact-actions {
  display: flex;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
}

.contact-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 2rem;
  border-radius: 4px;
  font-size: 1.1rem;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  min-width: 150px;
}

.contact-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.btn-primary {
  background-color: white;
  color: #28a745;
  border: 2px solid white;
}

.btn-primary:hover {
  background-color: transparent;
  color: white;
}

.btn-secondary {
  background-color: transparent;
  color: white;
  border: 2px solid white;
}

.btn-secondary:hover {
  background-color: white;
  color: #28a745;
}

.contact-btn i {
  margin-right: 0.5rem;
}

/* 响应式设计 */
@media (max-width: 767px) {
  .page-header h1 {
    font-size: 2.5rem;
  }
  
  .page-header p {
    font-size: 1.2rem;
  }
  
  .section-header h2 {
    font-size: 2rem;
  }
  
  .section-header p {
    font-size: 1rem;
  }
  
  .intro-content {
    padding: 1rem 0;
  }
  
  .case-img {
    height: 150px;
  }
  
  .advantage-item {
    flex-direction: column;
    text-align: center;
  }
  
  .advantage-number {
    margin-right: 0;
    margin-bottom: 1rem;
  }
  
  .contact-actions {
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 575px) {
  .page-header {
    padding: 3rem 0;
  }
  
  .page-header h1 {
    font-size: 2rem;
  }
  
  .product-intro,
  .core-features,
  .advantages,
  .use-cases,
  .cooperation-cases,
  .contact-consult {
    padding: 3rem 0;
  }
}
</style>